import { apiService } from './api';
import { AuthToken } from '../types';

export interface PinStaffMember {
  id: number;
  firstName: string;
  lastName: string;
  outletId?: number | null;
}

export const pinAuthService = {
  getStaff: (companyCode: string, outletId?: number) =>
    apiService.get<PinStaffMember[]>('/auth/pin-login/staff', {
      companyCode,
      ...(outletId ? { outletId } : {}),
    }),

  login: (companyCode: string, userId: number, pin: string) =>
    apiService.post<AuthToken>('/auth/pin-login', { companyCode, userId, pin }),
};
